import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import Divider from '@theme/components/molecule/Divider'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import PageAboutPurchaseBox from '@theme/components/content/PageAboutPurchaseBox'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'

export default {
  components: {
    AppTitle,
    Breadcrumbs,
    Divider,
    LayoutBase,
    PageAboutPurchaseBox,
    ProductsVisited,
    UniqueSellingPoints,
  },
  data() {
    return {
      breadcrumbs: [
        {
          title: this.$t('PageAboutPurchase.breadcrumbs.index'),
          path: this.localePath({ name: 'aboutPurchase' }),
        },
      ],
      items: {
        afterPurchase:
          this.$themeSettings.components.PageAboutPurchase.showAfterPurchase &&
          typeof this.$t('PageAboutPurchase.afterPurchase.items') === 'object' &&
          Object.keys(this.$t('PageAboutPurchase.afterPurchase.items')).length > 0
            ? this.$t('PageAboutPurchase.afterPurchase.items')
            : [],
        afterPurchaseIcons: {
          'document-edit': require('@icon/document-edit.svg'),
          clockwise: require('@icon/clockwise.svg'),
          swap: require('@icon/swap.svg'),
          person: require('@icon/person.svg'),
        },
        beforePurchase:
          this.$themeSettings.components.PageAboutPurchase.showBeforePurchase &&
          typeof this.$t('PageAboutPurchase.beforePurchase.items') === 'object' &&
          Object.keys(this.$t('PageAboutPurchase.beforePurchase.items')).length > 0
            ? this.$t('PageAboutPurchase.beforePurchase.items')
            : [],
        beforePurchaseIcons: {
          rocket: require('@icon/rocket.svg'),
          wallet: require('@icon/wallet.svg'),
          heart: require('@icon/heart.svg'),
          location: require('@icon/location.svg'),
          information: require('@icon/information.svg'),
          checklist: require('@icon/checklist.svg'),
          'user-id': require('@icon/user-id.svg'),
          cart: require('@icon/cart.svg'),
        },
      },
    }
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageAboutPurchase' })
  },
  mixins: [ImageUrlMixin, SeoMixin],
}
